import { render } from "./ReferralInformation.vue?vue&type=template&id=605ffbe2&ts=true"
import script from "./ReferralInformation.ts?vue&type=script&lang=ts&external"
export * from "./ReferralInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__